import { i18n } from "../i18n/i18n";

import React, { Component } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { findIndex } from 'lodash'
import routes from '../routes/routes'
import purchaseOrderItemApi, {
  PurchaseOrderItemData
} from '../apis/purchaseOrderItem.api'
import Card from '../components/Card'
import ContentLayout from '../components/ContentLayout'
import ContentMain from '../components/ContentMain'
import CardButton from '../components/CardButton'
import PageHeading from '../components/PageHeading'
import TableVertical, {
  TableVerticalHeader
} from '../components/TableVertical'

interface PurchaseOrderEditRouteState {
  id: number
}

interface PurchaseOrderProps
  extends RouteComponentProps<any, any, PurchaseOrderEditRouteState> {}

interface PurchaseOrderState {
  purchaseOrderItem: PurchaseOrderItemData | null
}

class PurchaseOrder extends Component<PurchaseOrderProps, PurchaseOrderState> {
  get headers (): TableVerticalHeader[] {
    const { purchaseOrderItem } = this.state
    if (
      !purchaseOrderItem ||
      !purchaseOrderItem.purchaseOrder ||
      !purchaseOrderItem.purchaseOrder
    ) return []
    const partNumberPath = () => {
      const { purchaseOrder } = purchaseOrderItem
      if (!purchaseOrder || !purchaseOrder.vendorSite || !purchaseOrder.vendorSite.items) return ''
      const items = purchaseOrder.vendorSite.items
      const itemId = purchaseOrderItem.itemId
      const itemIndex = findIndex(items, { id: itemId })
      return `purchaseOrder.vendorSite.items[${itemIndex}].contactSiteItem.partNumber`
    }
    return [
      { heading: i18n("Purchase order"), path: 'purchaseOrder.code' },
      { heading: i18n("Line"), path: 'purchaseOrder.line' },
      { heading: i18n("Vendor"),
        path: 'purchaseOrder.vendorSite.contact.vendor.name'
      },
      { heading: i18n("Vendor part number"), path: partNumberPath() },
      { heading: i18n("Item code"), path: 'item.code' },
      { heading: i18n("Item description"), path: 'item.description' },
      { heading: i18n("Line quantity"), path: 'quantity' },
      { heading: i18n("Received quantity"), path: 'receivedQuantity' },
      { heading: i18n("Delivery date"),
        path: 'purchaseOrder.deliveryAt',
        date: true
      },
      { heading: i18n("Created at"),
        path: 'purchaseOrder.createdAt',
        date: true,
        tooltip: 'purchaseOrder.createdUser.username'
      },
      { heading: i18n("Updated at"),
        path: 'purchaseOrder.updatedAt',
        date: true,
        tooltip: 'purchaseOrder.updatedUser.username'
      }
    ]
  }

  constructor (props: PurchaseOrderProps) {
    super(props)
    this.state = {
      purchaseOrderItem: null
    }
    this.handleEditClick = this.handleEditClick.bind(this)
  }

  get id () {
    return this.props.location.state.id
  }

  handleEditClick () {
    const pathname = routes.purchaseOrderEdit
    const state = { id: this.id }
    this.props.history.push({ pathname, state })
  }

  readPurchaseOrderItem () {
    purchaseOrderItemApi.read(this.id, purchaseOrderItem => {
      if (!purchaseOrderItem) return
      this.setState({ purchaseOrderItem })
    })
  }

  componentDidMount () {
    this.readPurchaseOrderItem()
  }

  render () {
    return (
      <ContentLayout>
        <ContentMain layout="half">
          <Card>
            <PageHeading
              text={i18n("View Purchase Order")}
              doc='purchase-orders-view-purchase-order' />
            <TableVertical
              headers={this.headers}
              data={this.state.purchaseOrderItem} />
            <CardButton
              proceedText={i18n("Edit")}
              cancelText={i18n("Back")}
              onProceedClick={this.handleEditClick} />
          </Card>
        </ContentMain>
      </ContentLayout>
    )
  }
}

export default withRouter(PurchaseOrder)
